<template>
  <div v-if="freshness" class="ins-fresh" :class="'lvl-' + (freshness.level || 'ok')">
    <span class="ins-fresh-dot" aria-hidden="true"></span>
    <span v-if="freshness.level === 'alert'">{{ subject }} looks overdue — check the nightly refresh.</span>
    <span v-else-if="freshness.level === 'lagging'">Catching up after the weekend.</span>
    <span v-else-if="freshness.level === 'warning'">Awaiting the first sync.</span>
    <span v-else>Data is current.</span>
    <span v-if="showMeta && freshness.data_through" class="ins-fresh-meta">
      Updated through {{ fmtDate(freshness.data_through) }}<template v-if="freshness.next_refresh_label"> · Next update {{ freshness.next_refresh_label }}</template>
    </span>
  </div>
</template>

<script>
/* Shared freshness badge for the Insights reports. Consumes the standard freshness object
 * ({ level: ok|warning|lagging|alert, data_through, next_refresh_label }). `subject` parametrizes
 * the "overdue" copy (e.g. "Work order data" / "Foundry data"). */
import { fmtDate } from "./insightsFormat";
export default {
  name: "InsFreshness",
  props: {
    freshness: { type: Object, default: null },
    subject: { type: String, default: "Report data" },
    showMeta: { type: Boolean, default: true },
  },
  methods: { fmtDate },
};
</script>

<style scoped>
.ins-fresh { display: inline-flex; align-items: center; gap: 8px; font-size: 12px; padding: 4px 12px; border-radius: 999px; background: #f1f5f9; color: #46525e; }
.ins-fresh-dot { width: 9px; height: 9px; border-radius: 50%; background: #3d9a5a; }
.ins-fresh.lvl-warning .ins-fresh-dot { background: #d9a441; }
.ins-fresh.lvl-lagging .ins-fresh-dot { background: #e0842f; }
.ins-fresh.lvl-alert .ins-fresh-dot { background: #cc4a3f; }
.ins-fresh-meta { color: #7a828b; margin-left: 4px; padding-left: 10px; border-left: 1px solid #d5dde3; }
html.dark-mode .ins-fresh { background: #2b313a; color: #cbd2d9; }
html.dark-mode .ins-fresh-meta { color: #aab3bd; border-left-color: #3a414a; }
</style>
